<script setup>
import { onMounted } from "vue";
import { router } from '@inertiajs/vue3';
import Layout from "../Components/Layout.vue";

const props = defineProps({
    link: String,
});

onMounted(() => {
    Telegram.WebApp.BackButton.show();
    Telegram.WebApp.BackButton.onClick(() => router.get('/'));

    Telegram.WebApp.MainButton.hideProgress();
    Telegram.WebApp.MainButton.setText('Вернуться назад');
    Telegram.WebApp.MainButton.onClick(function () {
        router.get(`/`);
    });
    Telegram.WebApp.MainButton.show();

    Telegram.WebApp.openLink(props.link);
});
</script>

<template>
    <Layout>
        <div class="p-4 space-y-4 bg-tgThemeSecondaryBgColor">
            <h1 class="text-2xl font-semibold">Переход на страницу оплаты...</h1>

            <div class="p-6 bg-tgThemeSectionBgColor rounded-lg">
                После оплаты ваш тариф будет активирован автоматически.
            </div>
        </div>
    </Layout>
</template>
